// 菜单 + 权限映射：唯一事实源，侧边栏渲染与路由守卫共用。
// perm: 需要的权限 key；super: 仅超级管理员可见/可访问。二者都无 = 任意登录用户可访问（隐藏/共享页）。
import { isSuper, hasPerm } from '@/utils/perm'

export const menuConfig = [
  {
    type: 'group', title: '收银台', icon: 'Monitor', children: [
      { path: '/console', title: '收银台', perm: 'console' },
      { path: '/console/wine-storage', title: '存取酒', perm: 'console.wine_storage' },
    ],
  },
  {
    type: 'group', title: '数据报表', icon: 'TrendCharts', children: [
      { path: '/report/lesson-income', title: '课时收入', perm: 'report.lesson_income' },
      { path: '/report/pending-settlement', title: '待结算', perm: 'report.pending_settlement' },
      { path: '/report/revenue', title: '营收情况', perm: 'report.revenue' },
      { path: '/report/analytics', title: '营收分析', perm: 'report.analytics' },
      { path: '/report/product-margin', title: '商品毛利', perm: 'report.product_margin' },
      { path: '/report/attendance', title: '考勤管理', perm: 'report.attendance' },
      { path: '/report/earnings', title: '教师收益', perm: 'report.earnings' },
      { path: '/report/operation-logs', title: '操作日志', perm: 'report.operation_logs' },
    ],
  },
  {
    type: 'group', title: '订单详情', icon: 'DataLine', children: [
      { path: '/lessons', title: '上课订单', perm: 'orders.lessons' },
      { path: '/orders/products', title: '商品订单', perm: 'orders.products' },
    ],
  },
  {
    type: 'group', title: '分账管理', icon: 'Money', children: [
      { path: '/royalty/balance', title: '账户余额', perm: 'royalty.balance' },
      { path: '/royalty/records', title: '分账记录', perm: 'royalty.records' },
      { path: '/royalty/share', title: '发起分账', perm: 'royalty.share' },
    ],
  },
  {
    type: 'group', title: '营销', icon: 'Promotion', children: [
      { path: '/marketing/oa-followers', title: '公众号会员', perm: 'marketing.oa_followers' },
      { path: '/marketing/members', title: '小程序会员', perm: 'marketing.members' },
    ],
  },
  {
    type: 'group', title: '系统配置', icon: 'Setting', children: [
      { path: '/rooms', title: '包厢管理', perm: 'system.rooms' },
      { path: '/teachers', title: '老师管理', perm: 'system.teachers' },
      { path: '/groups', title: '团队管理', perm: 'system.groups' },
      { path: '/products', title: '商品管理', perm: 'system.products' },
      { path: '/inventory-items', title: '存货管理', perm: 'system.inventory' },
      { path: '/stock-movements', title: '库存管理', perm: 'system.stock' },
      { path: '/billing-tiers', title: '课程费用管理', perm: 'system.billing_tiers' },
      { path: '/printers', title: '打印机管理', perm: 'system.printers' },
      { path: '/settings', title: '参数配置', perm: 'system.settings' },
      { path: '/admin-users', title: '用户管理', super: true },
      { path: '/dev-debug', title: '开发调试', super: true },
    ],
  },
]

// 单条菜单项当前用户是否可见
function canSee(node) {
  if (node.super) return isSuper()
  return hasPerm(node.perm)
}

// 过滤出当前用户可见的菜单（去掉空分组）
export function visibleMenu() {
  const out = []
  for (const node of menuConfig) {
    if (node.type === 'item') {
      if (canSee(node)) out.push(node)
    } else {
      const children = node.children.filter(canSee)
      if (children.length) out.push({ ...node, children })
    }
  }
  return out
}

// path → 菜单元数据（{perm, super}），不在菜单中的路由返回 null（视为共享/隐藏页，任意登录可访问）
export function pathMeta(path) {
  for (const node of menuConfig) {
    if (node.type === 'item') {
      if (node.path === path) return node
    } else {
      const hit = node.children.find(c => c.path === path)
      if (hit) return hit
    }
  }
  return null
}

// 当前路径当前用户是否有权访问
export function canAccess(path) {
  const meta = pathMeta(path)
  if (!meta) return true // 未登记的共享/隐藏页
  return canSee(meta)
}

// 登录后落地页：第一个可访问的菜单项；无任何可访问项返回 null（调用方需处理，避免死循环）
export function firstAllowedPath() {
  const menu = visibleMenu()
  for (const node of menu) {
    if (node.type === 'item') return node.path
    if (node.children && node.children.length) return node.children[0].path
  }
  return null
}
